import { Cmd, loop, Loop, LoopReducerWithDefinedState } from 'redux-loop';
import { mergeAll } from 'lodash/fp';
import {
  IssuerActionTypes,
  issuersFetch,
  IssuersFetch,
  issuersFetchFailure,
  IssuersFetchFailure,
  issuersFetchSuccess,
  IssuersFetchSuccess,
  LoadIssuerApp,
} from './actions';
import { IssuerActions } from './actions';
import { getIssuersEffect } from './effects';
import { RootActions, WithRootActionTypes } from 'store/actions';

export type IssuerAppShape = {
  hasIssuersToView: boolean;
  loading: boolean;
  error: Error | null;
  isInitial: boolean;
};

export const initialState: IssuerAppShape = {
  hasIssuersToView: false,
  loading: false,
  error: null,
  isInitial: true,
};

type IssuerLoop<A> = (state: IssuerAppShape, action: A) => IssuerAppShape | Loop<IssuerAppShape>;

const handleLoadIssuerApp: IssuerLoop<LoadIssuerApp> = (state) => {
  return loop(state, Cmd.list([Cmd.action(issuersFetch())]));
};

const handleIssuersFetch: IssuerLoop<IssuersFetch> = (state) => {
  return loop(
    mergeAll([state, { loading: true, error: false }]),
    Cmd.run(getIssuersEffect, {
      args: [Cmd.getState],
      successActionCreator: issuersFetchSuccess,
      failActionCreator: issuersFetchFailure,
    }),
  );
};

const handleIssuersFetchSuccess: IssuerLoop<IssuersFetchSuccess> = (state, { data }) => {
  return mergeAll([
    state,
    {
      hasIssuersToView: !!data.results.length,
      loading: false,
      error: null,
      isInitial: false,
    },
  ]);
};

const handleIssuersFetchFailure: IssuerLoop<IssuersFetchFailure> = (state, { error }) => {
  return mergeAll([
    state,
    {
      hasIssuersToView: false,
    },
  ]);
};

const reducer: LoopReducerWithDefinedState<IssuerAppShape, WithRootActionTypes<IssuerActionTypes>> = (
  state = initialState,
  action,
): IssuerAppShape | Loop<IssuerAppShape> => {
  switch (action.type) {
    case RootActions.RESET_STATE:
      return initialState;
    case IssuerActions.LOAD_APP:
      return handleLoadIssuerApp(state, action);
    case IssuerActions.ISSUERS_FETCH:
      return handleIssuersFetch(state, action);
    case IssuerActions.ISSUERS_FETCH_SUCCESS:
      return handleIssuersFetchSuccess(state, action);
    case IssuerActions.ISSUERS_FETCH_FAILURE:
      return handleIssuersFetchFailure(state, action);
    default:
      return state;
  }
};

export default reducer;
